import {LOCO_HEADER_COLOR, PROBLEM_COLORS, STATION_HEADER_COLORS} from "../GameStyleUI";
import arrow from "../../../images/gameplay_ui/icons/create_train/arrow.svg";
import {STATION_NAMES} from "../../../constants/Constants";
import GameData from "../../../gameplay/model/GameData";
import TrainCard from "./TrainCard";
import "./SmallTrainCard.css"

const SmallTrainCard = props =>{
    let path = props.path;
    let train = props.train;

    let hasBrokenLocos = props.train.locomotives.filter(id => GameData.CurrentGame.getLocoById(id).isBreakDown).length > 0;
    let colors = hasBrokenLocos ? PROBLEM_COLORS : LOCO_HEADER_COLOR[train.locoType ?? path.locoType];
    let prevStation = props.train.parentStationID;
    let nextStation;
    for (let i = 0; i < path.connectedStations.length; i++){
        if(prevStation !== path.connectedStations[i]){
            nextStation = path.connectedStations[i];
            break;
        }
    }
    let colorsStation1 = STATION_HEADER_COLORS[prevStation];
    let colorsStation2 = STATION_HEADER_COLORS[nextStation];

    return <div className="hover" onClick={props.onClick} style={{
        width: train.trainType === 0 ? "30px" : "66px",
        height: "30px",
        marginRight: "5px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        alignItems: "center",
        background:  `linear-gradient(180deg, ${colors[0]} 0%,${colors[1]} 100%)`
    }
    } title={STATION_NAMES[prevStation] + " -> " + STATION_NAMES[nextStation]}>
        <div className="hover__hover">  <TrainCard train={train} isCanFree={false} /></div>
        <div style={{
            fontSize: "12px",
            fontWeight:"bold",
            color: "white"
        }}>{(train.id + 1)}</div>
        <div style={{
            display: "flex",
            paddingBottom: "5px"
        }}>
            <div style={{
                width: "5px",
                height: "5px",
                background: `linear-gradient(180deg, ${colorsStation1[0]} 0%,${colorsStation1[1]} 100%)`,
                border: "1px solid white",
                margin: "1px",
                boxSizing: "border-box"
            }}>
                <div />
            </div>
            <img src={arrow} alt={"icon"}/>
            <div style={{
                width: "5px",
                height: "5px",
                background: `linear-gradient(180deg, ${colorsStation2[0]} 0%,${colorsStation2[1]} 100%)`,
                border: "1px solid white",
                margin: "1px",
                boxSizing: "border-box"
            }}>
                <div />
            </div>
        </div>


    </div>
}

export default SmallTrainCard;
